import React from "react";
import PropTypes from "prop-types";
import "./index.scss";

const InputField = ({
  placeholder,
  label,
  type,
  id,
  onChange,
  onBlur,
  onKeydown,
  value,
  disabled,
  required,
  error,
  style,
}) => {
  const handleBlur = (e) => {
    if (e.target && e.target.value.trim().length > 0) {
      e.target.classList.add("-filled");
    } else {
      e.target.classList.remove("-filled");
    }
    if (onBlur) {
      onBlur(e);
    }
  };

  const handleKeydown = (e) => {
    if (e.key === "Enter") {
      if (e.target && e.target.value.trim().length > 0) {
        e.target.classList.add("-filled");
      } else {
        e.target.classList.remove("-filled");
      }
    }
    if (onKeydown) {
      onKeydown(e);
    }
  };
  return (
    <div className="input-field" style={style}>
      {error && (
        <label htmlFor={id} className="label -error">
          {error}
        </label>
      )}
      <input
        id={id}
        type={type}
        name={id}
        placeholder={placeholder}
        className={`input  ${error ? "-error" : ""}`}
        onChange={onChange}
        onBlur={handleBlur}
        onKeyDown={handleKeydown}
        value={value || ""}
        disabled={disabled}
        required={required}
        autoComplete="none"
      />
      {label && (
        <label htmlFor={id} className="label">
          {label}
        </label>
      )}
    </div>
  );
};

InputField.propTypes = {
  required: PropTypes.bool,
  id: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onKeydown: PropTypes.func,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  style: PropTypes.shape([PropTypes.object]),
};

InputField.defaultProps = {
  required: false,
  type: "text",
  placeholder: "",
  id: "",
  label: "",
  onChange: () => {},
  onBlur: () => {},
  onKeydown: () => {},
  value: "",
  disabled: false,
  error: "",
  style: {},
};

export default InputField;
